import React, { useEffect } from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import useStyles from '../../assets/styles/style';
import RunScriptHeading from './RunScriptHeading';
import RunScriptForm from './RunScriptForm';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store/appStore';
import { useNavigate, useParams } from 'react-router-dom';

const RunScriptMain: React.FC = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const association_type = useSelector(
    (state: RootState) => state.projects.association_type
  );

  useEffect(() => {
    if (association_type && association_type === 'VENDOR') {
      navigate(`/project/${id}?tab=task`, { replace: true });
    }
  }, [association_type, id, navigate]);

  if (association_type === 'VENDOR') return null;

  return (
    <div className={classes.formMainContainer}>
      <Box className={classes.formMainHeadingBox}>
        <RunScriptHeading />
      </Box>
      <Box component="main" className={classes.formMainBox}>
        <Paper className={classes.formMainpaper}>
          <RunScriptForm />
        </Paper>
      </Box>
    </div>
  );
};

export default RunScriptMain;
